import {useState, useEffect} from 'react';
import {calculateExpireTime} from 'utilities/helper/expireTime';
const useProductCountDown = (expiredDay: string | undefined) => {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const getTime = () => {
    if (expiredDay) {
      const {daysRemain, hoursRemain} = calculateExpireTime(expiredDay);
      setHours(hoursRemain);
      setDays(daysRemain);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => getTime(), 1000);

    return () => clearInterval(interval);
  }, []);
  return {days, hours};
};

export default useProductCountDown;
